import { LandrBrand } from 'constants/brands';
import React from 'react';
import styled from 'styled-components';
import {
    Logo,
    palette,
    spacing,
    radius,
    ConditionalWrapper,
} from '@landr/maestro';
import { t } from '@lingui/macro';

export const StyledExclusiveCardBadge = styled.div`
    border-radius: ${radius('lg')};

    width: 100%;
    max-width: ${spacing('xxl')};
    max-height: 32px; /* maestro-no-token */
    background: ${palette('secondary.500')};
    display: flex;
    flex-direction: row;
    justify-content: center;
    pointer-events: none;

    svg {
        min-width: auto;
        min-height: auto;
        height: 75%;
        width: 100%;

        g path {
            color: ${palette('neutral.0')};
            stroke-width: 2.5;
        }
    }
`;

const ResponsiveTopRight = styled.div`
    position: absolute;
    top: 0;
    right: 0;

    max-width: 18.75%;
    pointer-events: none;

    ${StyledExclusiveCardBadge} {
        border-top-left-radius: 0;
        border-top-right-radius: ${radius('base')};
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 25%;
    }
`;

export const ExclusivePackBadge: React.FC<{
    isAbsolute?: boolean;
}> = ({ isAbsolute = false }) => (
    <ConditionalWrapper
        condition={isAbsolute}
        wrapper={(children: React.ReactNode): React.ReactNode => (
            <ResponsiveTopRight>{children}</ResponsiveTopRight>
        )}
    >
        <StyledExclusiveCardBadge aria-label={t`${LandrBrand} Exclusive`}>
            <Logo color="neutral.0" />
        </StyledExclusiveCardBadge>
    </ConditionalWrapper>
);

export default ExclusivePackBadge;
